import React from "react";

import { isNullOrUndefined } from "../../HWLibrary/HWUtils";
import { s360ConfigService } from "../../Services/S360Config";

import AudioMessage from "./AudioMessage";
import CloseMessage from "./CloseMessage";
import CustomMessage from "./CustomMessage";
import DocumentMessage from "./DocumentMessage";
import EmojiMessage from "./EmojiMessage";
import ImageMessage from "./ImageMessage";
import LocationMessage from "./LocationMessage";
import TextMessage from "./TextMessage";
import VideoMessage from "./VideoMessage";

function Message(props) {
  const showNewConversationOverlay = s360ConfigService.config.hideNewConversation;
  console.log(props.message,"showNewConversationOverlay")
  const getMessageComponent = () => {
    let convoType = props.message.convoType;

    switch (convoType) {
      case ConvoType.TEXT:
        return <TextMessage {...props} />;
      case ConvoType.EMOJI:
        return <EmojiMessage {...props} />;
      case ConvoType.IMAGE:
        return <ImageMessage {...props} />;
      case ConvoType.CUSTOM:
        return (
          <CustomMessage
            {...props}
            end={props?.message?.message?.chatResponse?.end}
            disabled={props.message.disabled}
          />
        );
      case ConvoType.VIDEO:
        return <VideoMessage {...props} />;
      case ConvoType.AUDIO:
        return <AudioMessage {...props} />;
      case ConvoType.LOCATION:
        return <LocationMessage {...props} />;
      case ConvoType.FILE:
        return <TextMessage {...props} />;
      case ConvoType.CLOSE:
        return isNullOrUndefined(showNewConversationOverlay) || !showNewConversationOverlay ? (
          <CloseMessage {...props} />
        ) : null;
      case ConvoType.TRANSFER:
        return <TextMessage {...props} />;
      case ConvoType.DOCUMENT:
        return <DocumentMessage {...props} />;
      default:
        return <TextMessage {...props} />;
    }
  };

  return (
    <>
      {getMessageComponent()}
    </>
  );
}

export const ConvoType = {
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  CUSTOM: "CUSTOM",
  VIDEO: "VIDEO",
  AUDIO: "AUDIO",
  LOCATION: "LOCATION",
  FILE: "FILE",
  CLOSE: "CLOSE",
  TRANSFER: "TRANSFER",
  DOCUMENT: "DOCUMENT",
  EMOJI: "EMOJI",
};

export const MessageType = {
  received: "RECEIVED",
  sent: "SENT",
  info: "INFO",
};

export default Message;
